import {css} from 'lit';
export const styles = css`:host {
  --value-color: var(--gray-900, #212529);
  --label-color: var(--gray-600, #868e96);

  display: block;
}

p {
  margin: 0;
}

.label {
  color: var(--label-color);
  font-size: 0.875rem;
  line-height: 1.25;
}

.value {
  margin-top: 4px;
  color: var(--value-color);
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.15;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.value.unavailable {
  color: var(--label-color);
}

.caption {
  margin-top: 4px;
  color: var(--label-color);
  font-size: 0.8125rem;
  line-height: 1.3;
}
`;
export default styles;
